import { Domain } from '@enums/Domain'
import { getUrlWithQueryParams } from '@utils/queryParamUtils'
import { getConfig } from './envConfig'

export const domainConfig = {
  [Domain.ACKO]: {
    events: {
      airpass: 'tap_btn_airpass',
      homePage: 'btn_explore_insurance',
    },
    style: () => '',
    onClick: url => (window.location.href = getUrlWithQueryParams(url, true)),
  },
  [Domain.ACKODRIVE]: {
    events: {
      homePage: 'track_event_complete',
    },
    style: styles => styles.isDrive,
    onClick: (url, env) => (window.location.href = getUrlWithQueryParams(`${getConfig(env).ackoDriveBaseUrl}${url}`)),
  },
}
